export const getWindowLocationPathname = () =>
  window?.location?.pathname ?? 'UnknownScreen';

/** Returns the current pathname with numeric IDs and UUIDs replaced by
 *  template tokens so SigNoz can group logs by screen without per-entity
 *  cardinality explosion (e.g. /projects/123 → /projects/:id). */
export const getNormalizedPathname = (): string => {
  const raw = window?.location?.pathname ?? 'UnknownScreen';
  return raw
    .replace(/\/\d+(?=\/|$)/g, '/:id')
    .replace(/\/[0-9a-f-]{36}(?=\/|$)/gi, '/:uuid');
};
